var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconConsumptionGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1115_685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.24992 4.58337H6.41659C5.93036 4.58337 5.46404 4.77653 5.12022 5.12034C4.77641 5.46416 4.58325 5.93048 4.58325 6.41671V17.4167C4.58325 17.9029 4.77641 18.3693 5.12022 18.7131C5.46404 19.0569 5.93036 19.25 6.41659 19.25H15.5833C16.0695 19.25 16.5358 19.0569 16.8796 18.7131C17.2234 18.3693 17.4166 17.9029 17.4166 17.4167V6.41671C17.4166 5.93048 17.2234 5.46416 16.8796 5.12034C16.5358 4.77653 16.0695 4.58337 15.5833 4.58337H13.7499",
    stroke: "#D9D9D9",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 2.75H10.0833C9.07081 2.75 8.25 3.57081 8.25 4.58333C8.25 5.59586 9.07081 6.41667 10.0833 6.41667H11.9167C12.9292 6.41667 13.75 5.59586 13.75 4.58333C13.75 3.57081 12.9292 2.75 11.9167 2.75Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.5833V11",
    stroke: "#D9D9D9",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15.5833V14.6666",
    stroke: "#D9D9D9",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 15.5834V12.8334",
    stroke: "#D9D9D9",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1115_685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConsumptionGrey);
export default __webpack_public_path__ + "static/media/Icon_Consumption_Grey.cc49c82a83c53b4dd1d03a088bf55638.svg";
export { ForwardRef as ReactComponent };